import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { StaticImage } from '@nxte-nl/static-image';

import { navigationHooks } from '../../hooks/navigationHooks/navigationHooks';
import { versionDependent } from '../../images/versionDependentExport';
import { Link, LinkIntent, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import styles from './NotFoundPageBody.module.css';

const messages = defineMessages({
  title: {
    id: 'src.components.NotFoundPageBody.title',
    defaultMessage: 'Oops... ',
  },
  description: {
    id: 'src.components.NotFoundPageBody.description',
    defaultMessage: `Unfortunately, the page you were looking for no longer exists or has moved.
    We are happy to help you search further.
    Return to the {link} or use the search bar at the top of the website.`,
  },
  homePageLink: {
    id: 'src.components.NotFoundPageBody.homePageLink',
    defaultMessage: 'home page',
  },
  imageAlt: {
    id: 'src.components.NotFoundPageBody.imageAlt',
    defaultMessage: 'Error 404',
  },
});

export const NotFoundPageBody = () => {
  const intl = useIntl();

  const imageAlt = intl.formatMessage(messages.imageAlt);

  return (
    <div className={styles.notFoundPageContainer}>

      <Typography variant='h1' className={styles.title}>
        <FormattedMessage {...messages.title} />
      </Typography>

      <Typography
        variant='bodySubText1'
        size='l'
        className={styles.description}
      >
        <FormattedMessage
          {...messages.description}
          values={{
            link: (
              <Link
                to={navigationHooks.useHomePageRedirect()()}
                type={LinkType.Href}
                intent={LinkIntent.primary}
                className={styles.link}
              >
                <FormattedMessage {...messages.homePageLink} />
              </Link>
            ),
          }}
        />
      </Typography>

      <StaticImage
        className={styles.image}
        alt={imageAlt}
        src={versionDependent.notFoundImage.src}
        width={versionDependent.notFoundImage.width ?? 200}
        height={'auto'}
      />
    </div >
  );
};

NotFoundPageBody.displayName = 'NotFoundPageBody';
